import React, { ChangeEvent, SelectHTMLAttributes } from "react"
import "./LearnerField.style.scss"

export interface LearnerSelectOption {
  value: string
  label: string
}

type LearnerSelectProps = {
  id: string
  label: string
  name: string
  value: string
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void
  options: LearnerSelectOption[]
  placeholder?: string
  error?: string
  disabled?: boolean
  autoFocus?: boolean
} & Omit<
  SelectHTMLAttributes<HTMLSelectElement>,
  | "id"
  | "name"
  | "value"
  | "onChange"
  | "disabled"
  | "autoFocus"
  | "children"
>

const LearnerSelect = ({
  id,
  label,
  name,
  value,
  onChange,
  options,
  placeholder = "Select…",
  error,
  disabled = false,
  autoFocus = false,
  ...rest
}: LearnerSelectProps) => (
  <div className="learner-field">
    <label htmlFor={id} className="learner-field__label">
      {label}
    </label>
    <div className="learner-field__control">
      <select
        id={id}
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        autoFocus={autoFocus}
        className={`learner-field__input learner-field__select${
          error ? " is-error" : ""
        }`}
        aria-invalid={!!error}
        {...rest}
      >
        <option value="" disabled>
          {placeholder}
        </option>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
    {error ? <p className="learner-field__error">{error}</p> : null}
  </div>
)

export default LearnerSelect
